import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { HelpLightElement } from "./help-light-element.js";
import "./jonas-suggestions.js";
import type { ChatSuggestion } from "./jonas-suggestions.js";
import type { ChatHomeTile } from "../home-tiles.js";

/**
 * The CMS preview of the chat-home prompts. Visitors meet these through the composer;
 * this renders the very same list, so an editor previews what actually ships.
 */
@customElement("help-jonas-home-prompts")
export class HelpJonasHomePrompts extends HelpLightElement {
  @property({ attribute: false })
  accessor tiles: ChatHomeTile[] = [];

  @property()
  accessor suggestionsLabel = "Suggesties";

  protected override render() {
    return html`<section class="home-prompts" data-chat-home-tiles>
      <help-jonas-suggestions
        .suggestions=${this.toSuggestions()}
        listLabel=${this.suggestionsLabel}
      ></help-jonas-suggestions>
    </section>`;
  }

  // The tile title is the editor's own handle on the tile; the description is what the
  // visitor reads as the question on offer.
  private toSuggestions(): ChatSuggestion[] {
    return this.tiles.map((tile) => ({
      id: tile.id,
      label: tile.description,
      question: tile.question,
    }));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "help-jonas-home-prompts": HelpJonasHomePrompts;
  }
}
